import { FC } from 'react';
import { Typography, TypographyProps } from '@mui/material';


interface Props extends TypographyProps {
  text?: string;
  maxLength?: number;
  mediumCount?: number;
  preferredLength?: number;
}

export const CharacterCount: FC<Props> = (props) => {
  const {
    text,
    maxLength,
    mediumCount,
    preferredLength,
    ...typographyProps
  } = props;

  const currentLength = text?.length || 0;
  const remaining = maxLength ? maxLength - currentLength : 0;

  if (maxLength === undefined || maxLength <= 0) {
    return null;
  }

  let color: TypographyProps['color'] = 'textSecondary';

  if (remaining < 0) {
    color = 'error.main';
  } else if (preferredLength && currentLength >= preferredLength) {
    color = 'success.main';
  } else if (mediumCount && currentLength >= mediumCount) {
    color = 'warning.main';
  }

  return (
    <Typography variant="caption" color={color} {...typographyProps}>
      {currentLength} / {maxLength}
    </Typography>
  );
};
